import {RefObject, useEffect} from 'react';

interface IInfiniteScroll {
    rootRef?: RefObject<HTMLElement> | null;
    boundaryRef: RefObject<HTMLElement> | null;
    onScrollToBoundary: () => void;
    active: boolean;
    margin?: string;
    isLoading?: boolean;
    threshold?: number[];
}

export const useInfiniteScroll = ({
    boundaryRef,
    rootRef,
    onScrollToBoundary,
    threshold = [0],
    margin = '0px',
    active,
}: IInfiniteScroll) => {
    useEffect(() => {
        const boundary = boundaryRef?.current;
        const root = rootRef?.current;
        let observer: IntersectionObserver | undefined;

        if (boundary && active && !observer) {
            observer = new IntersectionObserver(
                (entries) => {
                    if (!entries.find((entry) => entry.isIntersecting && entry.target === boundary)) {
                        return;
                    }
                    onScrollToBoundary();
                },
                {
                    root: root || null,
                    rootMargin: margin,
                    threshold,
                },
            );
            observer.observe(boundary);
        }

        if (!active && observer) {
            observer.disconnect();
        }

        return () => {
            if (observer) {
                observer.disconnect();
            }
        };
    }, [boundaryRef, onScrollToBoundary, threshold, margin, active, rootRef]);
};
